import React, { useContext, useState } from 'react';
import { Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import context from '../context';
import Form from './Form';
import Items from './Items';

const Topic: React.FC = () => {
  const { pageGroup } = useContext(context);
  const { t } = useTranslation();
  const [tabIndex, setTabIndex] = useState(0);
  return (
    <Tabs index={tabIndex} onChange={index => setTabIndex(index)}>
      <TabList>
        <Tab>{t('data')}</Tab>
        <Tab isDisabled={!pageGroup}>Itens</Tab>
      </TabList>
      <TabPanels>
        <TabPanel>
          <Form
            onCreated={() => {
              setTabIndex(1);
            }}
          />
        </TabPanel>
        <TabPanel>
          <Items />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};

export default Topic;
